import { QuestLayout } from "../components/QuestLayout";
import { QuestDisclaimer, QuestFlow } from "../components/QuestPrimitives";
import { QuestBrief } from "../components/QuestBrief";
import { useQuests } from "../useQuests";
import { isAccepting } from "../types";

const steps = [
  "Questを探す",
  "自分で選んで応募",
  "締切後、企業が選考",
  "契約を確認し挑戦へ",
];
export function JobQuestTop() {
  const { quests } = useQuests();
  const featured = quests.find((quest) => isAccepting(quest)) ?? quests[0];
  return (
    <QuestLayout current="top">
      <section className="jq-hero">
        <div className="content-width jq-hero-grid">
          <div className="jq-hero-copy">
            <p className="jq-eyebrow">
              OPEN THE QUEST BOARD / 企業から届いた挑戦
            </p>
            <h1>
              <span>AIYSS</span>JOB QUEST
              <span className="jq-title-dot" aria-hidden="true">
                .
              </span>
            </h1>
            <p className="jq-hero-catch">スキルを、実務で試そう。</p>
            <p className="jq-hero-description">
              企業から届いた業務委託案件をQuestとして掲載する、学生向けプロジェクトプラットフォーム。
            </p>
            <a className="jq-button" href="/job-quest/board/">
              Questを探す <span aria-hidden="true">↗</span>
            </a>
            <p className="jq-hero-note">
              高校生を中心とした学生のための、実務への入り口。
            </p>
          </div>
          {featured && (
            <div className="jq-hero-board">
              <QuestBrief quest={featured} />
            </div>
          )}
        </div>
      </section>
      <section className="jq-section content-width">
        <div className="jq-section-heading">
          <p className="jq-eyebrow">HOW TO START</p>
          <h2>始め方</h2>
          <p>
            興味のあるMissionを見つけたら、条件を確認してエントリー。応募後は、各企業が選考します。
          </p>
        </div>
        <QuestFlow steps={steps} />
        <QuestDisclaimer />
        <p className="jq-company-link">
          Questの掲載をご検討の企業様へ：
          <a href="/contact/?type=job-quest#contact">
            AIYSSへお問い合わせください →
          </a>
        </p>
      </section>
    </QuestLayout>
  );
}
